import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../_services';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        let currentUser = this.authenticationService.currentUserValue;
        if (currentUser && currentUser.token) {
            request = request.clone({
                setHeaders: { 
                    Auth: `Bearer:${currentUser.token}`
                }
            });
        }

        request = request.clone({ 
        url: `http://padangadmin.ezzysales.com/webservice/api/${request.url}` 
       //url: `http://teamworks/team1/BL-innovation/api/${request.url}` 
        });

        return next.handle(request);
    }
}